export default __webpack_public_path__ + "public/images/apart/living-banner@2x.png?6ca5df48";